import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=631dc6fd&scoped=true&"
import script from "./LoginLayout.vue?vue&type=script&lang=ts&"
export * from "./LoginLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultLayout.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./LoginLayout.vue?vue&type=style&index=1&id=631dc6fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631dc6fd",
  null
  
)

export default component.exports